import { render, staticRenderFns } from "./analyse-gasrealtimedata.vue?vue&type=template&id=90f613d6&scoped=true&"
import script from "./analyse-gasrealtimedata.vue?vue&type=script&lang=ts&"
export * from "./analyse-gasrealtimedata.vue?vue&type=script&lang=ts&"
import style0 from "./analyse-gasrealtimedata.vue?vue&type=style&index=0&id=90f613d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f613d6",
  null
  
)

export default component.exports